<app-header page=""></app-header>

<main class="container py-5 not-authorized-page">
  <div class="card border-0 shadow-sm mx-auto">
    <div class="card-body p-4 p-lg-5 text-center">
      <div class="not-authorized-icon mx-auto mb-3" aria-hidden="true">
        <i class="bi bi-shield-lock"></i>
      </div>
      <h1 class="h3 fw-bold mb-2">Access restricted</h1>
      <p class="text-muted mb-4">
        Your account does not have permission to open this area or perform this action.
      </p>
      <a class="btn btn-primary" [routerLink]="homeRoute">
        Return to my workspace
      </a>
    </div>
  </div>
</main>

<app-footer></app-footer>
